import { useMutation } from '@tanstack/react-query';
import { Button } from 'primereact/button';
import React, { useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import ErrorToast, { showToast } from '../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import firebaseErrorMessages from '../../../components/errorMessages/firebase';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import RegisterForm, {
  RegisterFormFields,
} from '../../../features/admin/roles/RegisterForm';
import { postRole, postRoleArgs } from '../../../services/admin/RolesService';
import SuccessFormMessage from '../../../components/messages/SuccessFormMessage';
import LoadingButton from '../../../components/inputs/LoadingButton';
import { processAccessForm } from '@/src/utils/roleUtils';

const RolesRegister = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const formMethods = useForm<RegisterFormFields>();
  const { handleSubmit } = formMethods;

  const { mutate, isLoading, isSuccess } = useMutation({
    mutationFn: (data: postRoleArgs) => {
      return postRole(data);
    },
    onError: (error: AxiosError) => {
      const errorData = error.response?.data as { code: string };
      showToast(
        'error',
        toast,
        'Register Role Error',
        firebaseErrorMessages[errorData?.code] ||
          'An error ocurred! please try again later',
        3000
      );
    },
  });

  const onSubmit = (data: RegisterFormFields) => {
    const { access, hidePhaseCodes } = data;

    const list = processAccessForm(access);

    const payload = {
      ...data,
      access: list,
      hidePhaseCodes: hidePhaseCodes === 'yes' ? true : false,
    };
    mutate(payload);
  };

  return (
    <div className="flex flex-column justify-content-center gap-5 pt-8">
      <ErrorToast toastRef={toast} />
      <div className="text-35px font-bold text-center mb-5">Register Role</div>
      {!isSuccess && (
        <FormProvider {...formMethods}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="max-w-600px mx-auto flex flex-column gap-5"
          >
            <RegisterForm />
            <div className="flex flex-wrap gap-2 mb-3">
              <Button
                onClick={() => {
                  navigate('/admin/roles');
                }}
                className="w-15rem bluwaiRed border-0 flex m-auto py-3"
              >
                <span className="mx-auto text-22px text-white">Cancel</span>
              </Button>
              <LoadingButton
                isLoading={isLoading}
                label="Register"
                className="w-15rem bluwaiBlue border-0 flex m-auto py-3"
                fontSize="text-22px"
              />
            </div>
          </form>
        </FormProvider>
      )}
      {isSuccess && (
        <SuccessFormMessage
          message="The role has been created!"
          redirectUrl="/admin/roles"
          redirectMessage="Click here to return to the roles page"
        />
      )}
    </div>
  );
};

export default RolesRegister;
